import {Type} from '@github-ui/react-query-persister/typebox'

// Formatted the following types using typebox to support the review requests API persister

const ReviewStateSchema = Type.Union([
  Type.Literal('pending'),
  Type.Literal('commented'),
  Type.Literal('approved'),
  Type.Literal('changes_requested'),
  Type.Literal('dismissed'),
])

const DeferredTypeSchema = Type.Union([Type.Literal('codeowner'), Type.Literal('copilot')])

const ReviewerBaseProperties = {
  id: Type.Number(),
  displayLogin: Type.String(),
  name: Type.Union([Type.String(), Type.Null()]),
  avatarUrl: Type.String(),
}

const UserReviewerSchema = Type.Object({
  ...ReviewerBaseProperties,
  reviewerType: Type.Literal('User'),
  organizationLogin: Type.Null(),
})

const TeamReviewerSchema = Type.Object({
  ...ReviewerBaseProperties,
  reviewerType: Type.Literal('Team'),
  organizationLogin: Type.Union([Type.String(), Type.Null()]),
})

const ReviewerSchema = Type.Union([UserReviewerSchema, TeamReviewerSchema])

const PendingReviewRequestBaseProperties = {
  reviewer: ReviewerSchema,
  isCodeOwner: Type.Boolean(),
  isCodeOwnerFromDelegation: Type.Boolean(),
  delegatedFromTeamName: Type.Union([Type.String(), Type.Null()]),
}

const ActivePendingReviewRequestSchema = Type.Object({
  ...PendingReviewRequestBaseProperties,
  deferredType: Type.Null(),
  createdAt: Type.Union([Type.String(), Type.Null()]),
})

const DeferredPendingReviewRequestSchema = Type.Object({
  ...PendingReviewRequestBaseProperties,
  deferredType: DeferredTypeSchema,
  createdAt: Type.Union([Type.String(), Type.Null()]),
})

const PendingReviewRequestSchema = Type.Union([ActivePendingReviewRequestSchema, DeferredPendingReviewRequestSchema])

const ThreadCountsSchema = Type.Object({
  total: Type.Number(),
  resolved: Type.Number(),
})

const CompletedReviewSchema = Type.Object({
  id: Type.Number(),
  canReRequest: Type.Boolean(),
  hasWriteAccess: Type.Boolean(),
  headSha: Type.String(),
  onBehalfOfTeamNames: Type.Array(Type.String()),
  reviewer: ReviewerSchema,
  state: ReviewStateSchema,
  submittedAt: Type.String(),
  threadCounts: ThreadCountsSchema,
})

const SuggestedReviewerSchema = Type.Object({
  reviewer: ReviewerSchema,
  description: Type.String(),
})

export const ReviewRequestsDataSchema = Type.Object({
  pendingReviewRequests: Type.Array(PendingReviewRequestSchema),
  completedReviews: Type.Array(CompletedReviewSchema),
  suggestedReviewers: Type.Array(SuggestedReviewerSchema),
})

export type ReviewState = Type.Static<typeof ReviewStateSchema>
export type DeferredType = Type.Static<typeof DeferredTypeSchema>
export type ReviewerType =
  | Type.Static<typeof UserReviewerSchema>['reviewerType']
  | Type.Static<typeof TeamReviewerSchema>['reviewerType']
export type Reviewer = Type.Static<typeof ReviewerSchema>
export type ActivePendingReviewRequest = Type.Static<typeof ActivePendingReviewRequestSchema>
export type DeferredPendingReviewRequest = Type.Static<typeof DeferredPendingReviewRequestSchema>
export type PendingReviewRequest = Type.Static<typeof PendingReviewRequestSchema>
export type CompletedReview = Type.Static<typeof CompletedReviewSchema>
export type SuggestedReviewer = Type.Static<typeof SuggestedReviewerSchema>
export type ReviewRequestsData = Type.Static<typeof ReviewRequestsDataSchema>
